/**
 * Execution type of a {@code DunningTypeExit} hook: which artifact is bound
 * at this extension point and how it is dispatched.
 *
 * Mirrors backend enum
 * {@code com.mvs.backend.bd.enums.BdDunningExitExecutionType}.
 * Ordinal mapping (MUST match the backend enum):
 *   0 = LOGIC_FLOW
 *   1 = NOTIFICATION
 *   2 = CONDITION
 *   3 = UI_ACTION
 *   4 = WORKFLOW
 *
 * @ticket bd-dunningtype-overview
 */
export enum BdDunningExitExecutionType {
    LOGIC_FLOW,
    NOTIFICATION,
    CONDITION,
    UI_ACTION,
    WORKFLOW
}

/**
 * German UI labels for BdDunningExitExecutionType values.
 */
export const BD_DUNNING_EXIT_EXECUTION_TYPE_LABELS: Record<BdDunningExitExecutionType, string> = {
    [BdDunningExitExecutionType.LOGIC_FLOW]: 'Logikfluss',
    [BdDunningExitExecutionType.NOTIFICATION]: 'Benachrichtigung',
    [BdDunningExitExecutionType.CONDITION]: 'Bedingung',
    [BdDunningExitExecutionType.UI_ACTION]: 'UI-Aktion',
    [BdDunningExitExecutionType.WORKFLOW]: 'Workflow'
};
